import { screeningAction } from '../../actions/constant';

const { GET_SINGLE_SCREENING_SUCCESS, GET_SINGLE_SCREENING_FAILURE } = screeningAction;

const intitialstate: object = {
  response: null,
  isError: false,
  errorMessage: '',
};

export const getSingleScreeningReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_SINGLE_SCREENING_SUCCESS: {
      return {
        ...state,
        isError: false,
        response: action.payload?.data,
      };
    }

    case GET_SINGLE_SCREENING_FAILURE:
      return {
        ...state,
        isError: true,
        errorMessage: action.payload,
        response: null,
      };

    default:
      return state;
  }
};
